import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { getThirdPartyPayment } from '../../api/getApi';
import DetailWrapper from '../../components/DetailWrapper/detailWrapper';
import useSpecPath from '../../hook/useSpecPath';
import GetParams from '../../utils/getParams';
import { waitTime } from '../../utils/waitTime';
import DepositStepOne from './DepositStepOne';

const Deposit = () => {
  const { t } = useTranslation();

  const [paymentList, setPaymentList] = useState({
    vip: [],
    third_party: []
  });
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCurrency, setSelectedCurrency] = useState(
    process.env.REACT_APP_DEFAULT_CURRENCY
  );

  const currency = GetParams('currency');

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await waitTime(1000);
      await getThirdPartyPayment({
        paramsData: {
          currency_code: currency || selectedCurrency
        }
      }).then((data) => {
        const vip = data?.vip || [];
        const third_party = data?.third_party || [];
        setPaymentList({
          vip,
          third_party
        });
      });

      setIsLoading(false);
    };

    fetchData();
  }, [selectedCurrency, currency]);
  return (
    <DetailWrapper>
      <DepositStepOne
        selectedCurrencyConfig={{
          selectedCurrency: selectedCurrency,
          setSelectedCurrency: setSelectedCurrency
        }}
        isLoading={isLoading}
        paymentList={paymentList}
      />

      {/* <Link to={`${getSpecPath}withdraw`}>
        <Text
          textAlign={`center`}
          my="10px"
          color="special.100"
          cursor={`pointer`}
        >
          {i18n("withdraw")}
        </Text>
      </Link> */}
    </DetailWrapper>
  );
};

export default Deposit;
